import $ from 'jquery'

export default function(o){

  var thumbServer = o.store('thumbServer')

  var set = function(roll, start, filter){

    var b = filter.split('_')[0].replace('b','')
    var c = filter.split('_')[1].replace('c','')
    var s = filter.split('_')[2].replace('s','')
    var url = `${thumbServer}filterThumb?roll=${roll}&start=${start}&b=${b}&c=${c}&s=${s}`

    div.css({
      backgroundImage: `url('${url}')`
    })

  }

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      backgroundSize: 'cover',
      width: '400px',
      height: '300px',
      top: 0,
      left: 0,
    })

  div.set = set

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/player/filter/filter.js